import { FlexBox, Spinner, Text } from '@dixa/lib-shared-habla';
import type { CustomCardIntegrationSanitized } from 'lib-shared-types-api';

import { integrationsApi } from 'apis/integrations';

import CustomCardsItem from '../../../../containers/sidebar/cards/customCardsItem';

export type CustomCardsProps = {
  isMinimized?: boolean;
  csid?: number | null;
};

const emptyArray: CustomCardIntegrationSanitized[] = [];

export const CustomCards = ({
  isMinimized = false,
  csid,
}: CustomCardsProps): JSX.Element => {
  const { customCards, isFetching, isError } =
    integrationsApi.useReadCustomCardIntegrationsSanitizedQuery(undefined, {
      selectFromResult: ({ data, ...rest }) => ({
        ...rest,
        customCards: data?.data.custom_cards || emptyArray,
      }),
    });

  if (isError) {
    return (
      <FlexBox justifyContent="center" padding="400">
        <Text.Paragraph>
          Something went wrong fetching custom cards.
        </Text.Paragraph>
      </FlexBox>
    );
  }

  return (
    <>
      {isFetching ? (
        <FlexBox justifyContent="center" padding="400">
          <Spinner />
        </FlexBox>
      ) : (
        [...customCards]
          .sort((a, b) => a.title.localeCompare(b.title))
          .map((card) => (
            <CustomCardsItem
              key={card.id}
              card={card}
              isMinimized={isMinimized}
              csid={csid}
            />
          ))
      )}
    </>
  );
};
